<template>
  <div class="experience-wrapper--tab-overview">
    <LadItineraryDownload
      cache-prefix="experience-download-itinerary"
      :cache-key="cacheKey"
    />

    <!-- <el-card v-if="isPackage" shadow="never" class="card--itinerary">
      <h3 slot="header">{{ $t(`${base}.preview.title`) }}</h3>

      <LadBoxItinerary :base="base" />
    </el-card> -->

    <el-card class="box-card itinerary-section" shadow="never">
      <div slot="header" class="clearfix">
        <h2 class="section-title">{{ sectionTitle }}</h2>
      </div>

      <LadItinerarySection v-if="hasItinerary" />

      <LazyHydrate v-else-if="isBot" never>
        <div class="section-description" v-html="exDescription"></div>
      </LazyHydrate>

      <div v-else class="section-description" v-html="exDescription"></div>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { hydrateWhenVisible } from 'vue-lazy-hydration'

export default {
  name: 'LadTabOverview',
  components: {
    // LadBoxItinerary: () =>
    //   import(
    //     /* webpackChunkName: "lad-box-itinerary" */ '@/components/preview-itinerary/box'
    //   ),
    LadItineraryDownload: hydrateWhenVisible(() =>
      import(
        /* webpackChunkName: "lad-itinerary-download" */ '@/components/itinerary/download/index'
      )
    ),
    LadItinerarySection: () =>
      import(
        /* webpackChunkName: "lad-itinerary-section" */ '@/components/itinerary/section/index'
      ),
  },
  data() {
    return {
      base: 'experience.overview',
    }
  },
  computed: {
    ...mapState('experience', {
      exExperience: (state) => ({
        uuid: state.experience.uuid,
        name: state.experience.name,
      }),
      exItinerary: (state) => state.itinerary,
      exDescription: (state) => state.experience.brief_description,
      isPackage: (state) => state.experience.type === 'package',
    }),
    ...mapState('settings', ['currency']),
    ...mapState('device', {
      isBot: 'isBot',
    }),
    ...mapGetters('settings', ['language']),
    ...mapGetters('device', ['isMobile']),
    hasItinerary() {
      return this.exItinerary.length > 0
    },
    sectionTitle() {
      return this.hasItinerary
        ? this.$t(`${this.base}.itinerary`, { name: this.exExperience.name })
        : this.$t(`${this.base}.about_experience`)
    },
    cacheKey() {
      return `${this.exExperience.uuid}--${this.language}-${this.currency}--${
        this.isMobile ? 'm' : 'd'
      }`
    },
  },
}
</script>

<style lang="scss">
.experience-wrapper--tab-overview {
  margin-top: 20px;
  // margin-bottom: 25px;

  .lad-itinerary-download {
    .el-card__body {
      padding: 15px 20px;
    }
  }

  .card--itinerary,
  .itinerary-section {
    margin-top: 0 !important;
  }

  .card--itinerary {
    .el-card__header {
      h3 {
        margin: 0;
      }
    }
  }

  .itinerary-section {
    .el-card__header {
      border-bottom-color: transparent;
      padding-top: 2.5em;
    }
    .el-card__body {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
    }

    .section-title {
      margin: 0;
    }

    .section-description {
      padding: 0 20px 30px;
    }
  }
}
</style>
